<div loading-spin [isLoading]="reloading" [loadingSize]="'big'" class="container">
    <tam-grid [config]="gridConfig"></tam-grid>
</div>